import { render, staticRenderFns } from "./DialogConfirmAdd.vue?vue&type=template&id=88c53e46&"
import script from "./DialogConfirmAdd.vue?vue&type=script&lang=js&"
export * from "./DialogConfirmAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports